// /src/pages/dashboard/accounts/dropdowns.js
import React from 'react'
import { Dropdown } from 'react-bootstrap'

export function renderFacebookOptions({ openFbDeleteModal }) {
  return (
    <Dropdown className="ms-auto">
      <Dropdown.Toggle variant="light" size="sm">
        <i className="fas fa-ellipsis-h" />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={openFbDeleteModal}>
          Edit Accounts
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}


export function renderInstagramOptions({ setSelectedIgIds, setShowIgDeleteModal }) {
  return (
    <Dropdown className="ms-auto">
      <Dropdown.Toggle variant="light" size="sm">
        <i className="fas fa-ellipsis-h"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item
          onClick={() => {
            setSelectedIgIds([]);
            setShowIgDeleteModal(true);
          }}
        >
          Edit Accounts
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export function renderThreadsOptions({ setSelectedThreadsIds, setShowThreadsDeleteModal }) {
  return (
    <Dropdown className="ms-auto">
      <Dropdown.Toggle variant="light" size="sm">
        <i className="fas fa-ellipsis-h"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item
          onClick={() => {
            setSelectedThreadsIds([]);
            setShowThreadsDeleteModal(true);
          }}
        >
          Edit Accounts
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export function renderXOptions({ setSelectedXIds, setShowXDeleteModal }) {
  return (
    <Dropdown className="ms-auto">
      <Dropdown.Toggle variant="light" size="sm">
        <i className="fas fa-ellipsis-h"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item
          onClick={() => {
            setSelectedXIds([]);
            setShowXDeleteModal(true);
          }}
        >
          Edit Accounts
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export function renderLinkedInOptions({ setSelectedLnCombined, setShowLnUnifiedModal, setShowLnDeleteModal }) {
  return (
    <Dropdown className="ms-auto">
      <Dropdown.Toggle variant="light" size="sm">
        <i className="fas fa-ellipsis-h"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item
          onClick={() => {
            setSelectedLnCombined([]);
            setShowLnUnifiedModal(true);
          }}
        >
          Edit Accounts/Pages
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => {
            setShowLnDeleteModal(true);
          }}
        >
          Delete LN Personal
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export function renderTikTokOptions({ setSelectedTikTokIds, setShowTikTokDeleteModal }) {
  return (
    <Dropdown className="ms-auto">
      <Dropdown.Toggle variant="light" size="sm">
        <i className="fas fa-ellipsis-h"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item
          onClick={() => {
            setSelectedTikTokIds([]);
            setShowTikTokDeleteModal(true);
          }}
        >
          Edit Accounts
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export function renderPinterestOptions({ setSelectedPinterestIds, setShowPinterestDeleteModal }) {
  return (
    <Dropdown className="ms-auto">
      <Dropdown.Toggle variant="light" size="sm">
        <i className="fas fa-ellipsis-h"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item
          onClick={() => {
            setSelectedPinterestIds([]);
            setShowPinterestDeleteModal(true);
          }}
        >
          Edit Accounts
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export function renderYouTubeOptions({ setSelectedYouTubeIds, setShowYouTubeDeleteModal }) {
  return (
    <Dropdown className="ms-auto">
      <Dropdown.Toggle variant="light" size="sm">
        <i className="fas fa-ellipsis-h"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item
          onClick={() => {
            setSelectedYouTubeIds([]);
            setShowYouTubeDeleteModal(true);
          }}
        >
          Edit Accounts
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}
